import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation } from "@react-navigation/native";
import StatsCard from "./StatsCard";
import WalletFilters from "./WalletFilters";
import { actions as walletActions } from "@reducers/oldWalletReducer";
import { useDispatch, useSelector } from "react-redux";
import analytics from "@services/analytics";
import { VIEW_TRANSACTION_SCREEN } from "../../constants/analyticsEvents";

const LeaderWalletStats = () => {
  const navigation = useNavigation();
  const { walletSummary } = useSelector((state) => state.wallet);
  const dispatch = useDispatch();

  const handleCardPress = (payload) => {
    dispatch(walletActions.setCurrentScreen(payload));
    navigation.navigate("WalletDynamicScreen");
  };

  return (
    <View style={styles.statsContainer}>
      <WalletFilters containerBgColor={"#ffffff"} />

      <View
        style={{ padding: 5, flex: 1, flexDirection: "row", flexWrap: "wrap" }}
      >
        {walletSummary.summary &&
          Array.isArray(walletSummary.summary) &&
          walletSummary.summary.map((summary, index) => (
            <StatsCard
              index={index}
              key={summary.key}
              normalCardData={{
                title: summary.label,
                value: `₹${summary.value}`,
              }}
              orderCommissionNormalData={
                walletSummary.summary.type !== "commission-credit"
                  ? Array.isArray(summary.data)
                    ? summary.data.map((s) => ({
                        title: s.label,
                        value: `₹${s.value}`,
                      }))
                    : null
                  : null
              }
              secondaryStats={
                summary.key !== "commission-credit" &&
                summary.key !== "tp-commission-credit" &&
                Array.isArray(summary.data)
              }
              secondaryStatsData={
                Array.isArray(summary.data)
                  ? summary.data.map((s) => ({
                      title: s.label,
                      value: `₹${s.value}`,
                    }))
                  : []
              }
              normalCard
              handlePress={
                summary.count
                  ? () => {
                      handleCardPress({
                        title: summary.label,
                        type: summary.key,
                      });
                    }
                  : null
              }
            />
          ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  statsContainer: {
    flex: 1,
    // marginVertical: 10,
    paddingVertical: 10,
    paddingHorizontal: 5,
    backgroundColor: "#fff",
    // padding: 10
  },
  secondaryText: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  filterContainer: {
    justifyContent: "space-between",
    borderWidth: 1,
    borderColor: "transparent",
    borderBottomColor: "#ddd",
    padding: 10,
  },
});

export default LeaderWalletStats;
